const Strings = {
  SIGN_IN: {
    SE: 'Logga in',
    EN: 'Sign in'
  },
  EMAIL_ADDRESS: {
    SE: 'Mailadress',
    EN: 'Email address'
  },
  PASSWORD: {
    SE: 'Lösenord',
    EN: 'Password'
  },
  CREATE_ACCOUNT: {
    SE: 'Skapa konto',
    EN: 'Create account'
  },
  FORGOT_PASSWORD: {
    SE: 'Glömt lösenord?',
    EN: 'Forgot your password?'
  }
}

export default Strings



// WEBPACK FOOTER //
// ./src/components/pages/preLogin/Login/strings.js